var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navMargin"},[_c('NavBar',{attrs:{"scroll-padding":true,"transparent-on-top":true}}),_c('div',{staticStyle:{"margin-left":"5%","margin-right":"5%"}},[_c('h1',[_vm._v(_vm._s(_vm.content.title))]),_vm._l((_vm.content.page.split('\n')),function(line){return _c('p',{key:line.id},[_vm._v(_vm._s(line))])})],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }